import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleMonthYearPicker from "../../../modules/SimpleMonthYearPicker";

class PoUnitFilter extends Component {
  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        ...(name === "tanggalAkhir" || name === "tanggalAwal"
          ? {
              poDate: {
                ...prevValue.filterData.poDate,
                [name]: value,
              },
            }
          : {
              [name]: value,
            }),
      },
    }));
  };

  handleReset = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.props.onSubmit();
              }}
            >
              <SimpleInput
                id="input_text_po_no"
                name="poNo"
                label="PO No."
                value={this.props.state.filterData?.poNo}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <FlexView column vAlignContent="center">
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>Tanggal PO:</h4>
                </div>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    id="select_date_tglmutasi_from"
                    name="tanggalAwal"
                    nextdate
                    date={this.props.state.filterData.poDate?.tanggalAwal}
                    maxDate={this.props.state.filterData.poDate?.tanggalAkhir}
                    onChange={(value) => this.handleValueChange("tanggalAwal", value)}
                  />
                  <span className="margin-bottom-20px">s/d</span>
                  <SimpleDate
                    id="select_date_tglmutasi_to"
                    name="tanggalAkhir"
                    nextdate
                    date={this.props.state.filterData.poDate?.tanggalAkhir}
                    onChange={(value) => this.handleValueChange("tanggalAkhir", value)}
                  />
                </FlexView>
              </FlexView>
              <SimpleMonthYearPicker
                id="select_date_month_year"
                label="PO Month"
                value={this.props.state.filterData?.poMonth}
                onChange={(value) => this.handleValueChange("poMonth", value)}
              />
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton type="button" onClick={this.handleReset}>
                  Clear
                </SimpleButton>
                <SimpleButton type="submit">Terapkan</SimpleButton>
              </FlexView>
            </form>
          </ModalContainer>
        }
      />
    );
  }
}

export default PoUnitFilter;
